export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const DELETE_FLASH_MESSAGE = 'DELETE_FLASH_MESSAGE';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';



// WEBPACK FOOTER //
// ./src/constants/index.js